import apollo from "@/apollo.js"
import gql from "graphql-tag"

export const deleteFileAttachment = async (fileId) => {
  const response = await apollo.mutate({
    mutation: gql(`
        mutation deleteFileAttachment($fileAttachmentId: Int!) {
            deleteFileAttachment(fileAttachmentId: $fileAttachmentId ) { error message }
        }`),
    variables: { fileAttachmentId: fileId },
  })
  return response.data.deleteFileAttachment
}

export const renameFileAttachment = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation renameFileAttachment($fileAttachmentId: Int!, $newFileName: String!) {
        renameFileAttachment(fileAttachmentId: $fileAttachmentId, newFileName: $newFileName) {
          fileAttachment { 
            id
            userDisplayName
            url
            createdAt
            updatedAt
            size
            filename
            extension
            contentType
            hidden
        }
          error
          message
        }
      }`),
    variables: { fileAttachmentId: data.fileAttachmentId, newFileName: data.newFileName },
  })
  return response.data.renameFileAttachment
}

export const hideFileAttachment = async (data) => {
  console.log("provider", "hideFileAttachment", data)
  const response = await apollo.mutate({
    mutation: gql(`
      mutation hideFileAttachment($fileAttachmentId: Int!) {
        hideFileAttachment(fileAttachmentId: $fileAttachmentId) {
        fileAttachment {
            id
            userDisplayName
            url
            createdAt
            updatedAt
            size
            filename
            extension
            contentType
            hidden
          }
          error
          message
    }}`),
    variables: { fileAttachmentId: data.id },
  })
  console.log("after mutation...", response.data)
  return response.data.hideFileAttachment
}

export const showFileAttachment = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation showFileAttachment($fileAttachmentId: Int!) {
        showFileAttachment(fileAttachmentId: $fileAttachmentId) {
        fileAttachment {
            id
            userDisplayName
            url
            createdAt
            updatedAt
            size
            filename
            extension
            contentType
            hidden
          }
          error
          message
        }
      }`),
    variables: { fileAttachmentId: data.id },
  })
  console.log("after mutation...", response.data)
  return response.data.showFileAttachment
}

export const duplicateFileAttachment = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation duplicateFileAttachment($fileAttachmentId: Int!, $newFilePath: String!) {
        duplicateFileAttachment(fileAttachmentId: $fileAttachmentId, newFilePath: $newFilePath) {
          fileAttachment {
            id
            userDisplayName
            url
            createdAt
            updatedAt
            size
            filename
            extension
            contentType 
          }
          error
          message
          lowLevelErrorMessage
        }
      }`),
    variables: { fileAttachmentId: data.fileAttachmentId, newFilePath: data.newFilePath },
  })
  return response.data.duplicateFileAttachment
}

export const moveFileAttachment = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
      mutation moveFileAttachment($fileAttachmentId: Int!, $newFilePath: String!) {
        moveFileAttachment(fileAttachmentId: $fileAttachmentId, newFilePath: $newFilePath) {
          fileAttachment {
            id
            userDisplayName
            url
            createdAt
            updatedAt
            size
            filename
            extension
            contentType 
          }
          error
          message
          lowLevelErrorMessage
        }
      }`),
    variables: { fileAttachmentId: data.fileAttachmentId, newFilePath: data.newFilePath },
  })
  return response.data.moveFileAttachment
}
